import { useCurrentSite } from '../providers/currentSite/useCurrentSite';

export function useLocale() {
    const { currentSite } = useCurrentSite();

    return {
        locale: currentSite.locale,
        localeEvaneos: currentSite.localeEvaneos,
    };
}
